export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-960-54391d26df68f177b27b958ac37f54bc.png";